<div *ngIf="!(authService.isLoggedIn$ | async); else loggedIn">
  <ion-list>
    <ion-item>
      <ion-label position="stacked">Username</ion-label>
      <ion-input [(ngModel)]="credentials.username" type="text" placeholder="Username"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Password</ion-label>
      <ion-input [(ngModel)]="credentials.password" type="password" placeholder="Password"></ion-input>
    </ion-item>
  </ion-list>

  <p *ngIf="error" style="color: var(--ion-color-danger); padding: 0 16px;">
    {{ error }}
  </p>

  <ion-button expand="block" (click)="login()" [disabled]="isLoading">
    {{ isLoading ? 'Logging in...' : 'Login' }}
  </ion-button>
</div>

<ng-template #loggedIn>
  <div style="padding: 16px; display: flex; align-items: center; justify-content: space-between;">
    <span>Authenticated as: {{ authService.username$ | async }}</span>
    <ion-button size="small" (click)="logout()">Logout</ion-button>
  </div>
</ng-template>
